import React from "react";
import { Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import {option} from "../../../../helpers/DropDownOption"
import ret from "../../../../redux/configureStore";

class Heading extends React.Component {
   constructor(props){
    super(props);  
    this.state = {  
        on: false,  
      }  
   }

    render() {
        const onClick = (link, config) => {
            this.props.setLink(link, config)
        }


        return (
            <div className="heading">
                <h4>{!this.props.Links && (this.props.total && this.props.total > 0 ) ? `${this.props.name} (${this.props.total})` : this.props.name}</h4>
                <ul>
                    {/* <li>
                        {this.props.onRefresh &&
                            <Link to={"#"} onClick={(e)=>{
                            e.preventDefault();
                            this.props.onRefresh();
                            }}>
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"></path></svg>
                                Refresh
                            </Link>
                        }
                    </li> */}
                    {this.props.searchInput &&
                    <>
                    <label>Search</label> <input onChange={(e)=>{
                        this.props.searchFunction(e.target.value)
                        }} />
                    </>}

                    {this.props.search &&
                        <><li>
                            <Link to='' className="searchbar" onClick={() => {
                                this.props.setSearchBox(true)
                            }}>
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"> </path>
                                </svg>
                                Search
                            </Link>

                        </li>
                       {localStorage.getItem(`${this.props.query}`) && <li>
                            <Link to='' className="searchbar" onClick={() => {
                                this.props.lonRefresh();
                            }}>
                                Clear filter
                            </Link>

                        </li>}
                        </>
                    }

                    {this.props.yearChange &&<li>< Form.Select onChange={this.props.yearChange}>
                    <option value={2025}>2025</option>
                    <option value={2024}>2024</option>
                    <option value={2023}>2023</option>
                    <option value={2022}>2022</option>
                    </Form.Select></li>}

                    {
                        this.props.school &&<li style={{width:160}}>< Form.Select onChange={(e)=>{console.log(e.target);  this.props.schoolChange(e.target.value)}}>
                            <option value={0}>Select School</option>
                        {  
                            this.props.school.map(element=>{
                                return <option value={element.value}>{element.name}</option>
                            })    
                        }
                        </Form.Select></li>
                    }

{
                        this.props.departmentList && <li style={{width:160}}>< Form.Select onChange={(e)=>{console.log(e.target);  this.props.departmentChange(e.target.value)}}>
                            <option value="All">Select Department</option>
                        {  
                            this.props.departmentList.map(element=>{
                                return <option value={element.id}>{element.name}</option>
                            })    
                        }
                        </Form.Select></li>
                    }

                    {
                        this.props.typeChange &&<li>< Form.Select onChange={(e)=>{console.log(e.target);  this.props.typeChange(e.target.value)}}>
                            <option value="All">Select Type</option>
                        {  
                            option.EventWith.map(element=>{
                                return <option value={element}>{element}</option>
                            })    
                        }
                        </Form.Select></li>
                    }

                    {this.props.Button &&
                        <li>
                            <Link to='' className="Download_Cert" onClick={() => {
                                this.props.Button.callbackfunction();
                            }}>
                                {!this.state.on ? "Download Certificate" : "Please Wait"}
                            </Link>
                        </li>}

                    {/* <li>
                        <div class="search-bar">
                            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"> </path>     
                            </svg>
                            <input type="search" class="form-control searchInput" placeholder="Type keyword"/>
                        </div>
                        </li> */}

                    {this.props.link &&
                        <li>
                            <Link to={this.props.link}>
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
                                {this.props.linkName}
                            </Link>
                        </li>
                    }
                    {this.props.arrayName &&
                    this.props.arrayName.map((map,index)=>{
                        return <li>
                            <Link to={this.props.arrayLink[index]}>
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
                                {this.props.arrayName[index]}
                            </Link>
                        </li>
                    })}

                    {this.props.url === 'certificates' &&
                        <li>
                            <Link to={this.props.Import}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                                    viewBox="0 0 24 24" fill="#175CD3" stroke="white" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2-2.4-3.5-4.4-3.5h-1.2c-.7-3-3.2-5.2-6.2-5.6-3-.3-5.9 1.3-7.3 4-1.2 2.5-1 6.5.5 8.8M12 19.8V12M16 17l-4 4-4-4" /></svg>
                                Import
                            </Link>
                        </li>
                    }

                    {this.props.export && <li>
                        <button type="button" onClick={() => { this.props.export() }} className="export-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21"
                                viewBox="0 0 24 24" fill="#007745" stroke="white" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round">
                                <path d="M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2-2.4-3.5-4.4-3.5h-1.2c-.7-3-3.2-5.2-6.2-5.6-3-.3-5.9 1.3-7.3 4-1.2 2.5-1 6.5.5 8.8m8.7-1.6V21" /><path d="M16 16l-4-4-4 4" /></svg>
                            Export
                        </button>
                    </li>}

                    {this.props.certificate && <li><button className='btn btn-primary btn' onClick={() => { this.props.navigate(`/templates/${this.props.certificate}/certificates`); }}>View Certificates</button></li>}
                    {this.props.certificate && <li><button className='btn btn-primary btn' onClick={() => { this.props.navigate(`/pastEventTemplates/${this.props.certificate}`); }} style={{ marginLeft: 20, marginRight: 10 }}>Create Certificate Template</button></li>}
             
                    
                </ul>

            </div>
        )
    }
}

export default Heading;
